import { db } from "../lib/firebaseApp";
import {
    doc,
    deleteDoc,
    getDocs,
    setDoc,
    collection,
    addDoc,
    serverTimestamp,
    getDoc,
    query,
    where,
    onSnapshot,
    getCountFromServer
} from "firebase/firestore";

import { f_import_cow_array, f_update_cows_param, f_delete_cows_param, f_recursive_delete } from "./fbFunctions";







// ------------------------------------------------------------------------
export const add_Cow = async (user_id, event_id, data, cb_error) => {
    try {
        const docRef = await addDoc(collection(db, "EVENTS", event_id, "COWS"), {
            ...data,
            createTimestamp: serverTimestamp(),
            createBy: user_id
        })
        return (docRef.id)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> add_Cow:\n", error)
        }
        return (undefined)
    }
}


// ------------------------------------------------------------------------
export const edit_Cow = async (user_id, event_id, cow_id, data, cb_error) => {
    try {
        const docRef = await setDoc(doc(db, "EVENTS", event_id, "COWS", cow_id), {
            ...data,
            id: cow_id,
            updateTimestamp: serverTimestamp(),
            lastUpdateBy: user_id
        })

        return (docRef)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> edit_Cow:\n", error)
        }
        return (undefined)
    }
}

// ------------------------------------------------------------------------
export const delete_Cow = async (event_id, cow_id, cb_error) => {
    try {
        const docSnap = await (getDoc(doc(db, "EVENTS", event_id, "COWS", cow_id)))
        if (docSnap.exists()) {
            await deleteDoc(doc(db, "EVENTS", event_id, "COWS", cow_id));
            return (true)
        } else {
            return (false)
        }
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> delete_Cow:\n", error)
        }
        return (undefined)
    }
}

// ------------------------------------------------------------------------
export const get_Cow_byID = async (event_id, cow_id, cb_error) => {
    try {
        const docSnap = await (getDoc(doc(db, "EVENTS", event_id, "COWS", cow_id)))
        if (docSnap.exists()) {
            const data = docSnap.data()
            const doc = {
                ...data,
                id: docSnap.id,
            }
            return (doc)
        } else {
            return (undefined)
        }
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_Cow_byID:\n", error)
        }
        return (undefined)
    }
}

// ------------------------------------------------------------------------
export const get_Cow_list = async (event_id, cow_type, cb_error) => {
    try {
        const cow_list = []
        let q = query(collection(db, "EVENTS", event_id, "COWS"))
        if (cow_type != null) q = query(q, where("cow_type", "==", cow_type))

        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            const cow_data = {
                ...data,
                id: doc.id,
            }
            //DEBUG: console.log(doc.id, " => ", cow_data);
            cow_list.push(cow_data)
        });
        return (cow_list)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_Cow_list:\n", error)
        }
        return ([])
    }
}






/**
 * getting LIVE changing in collection "COWS" inside a selected event
 * Return value is a dictionary :
 * {
 *  modifiedList,   // modified cows (referred to previous call)
 *  addedList,      // addedd cows (referred to previous call)
 *  removedList     // removed cows (referred to previous call)
 * }
 * 
 * 
 * @param {string} event_id - firebase event id
 * @param {callback} cb_cows_live - callback function call everytime status change
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {function } unsubscribe function: has to be called for close LIVE listening
*/
export const get_cows_live = async (event_id, cb_cows_live, cb_error) => {
    try {
        console.log("GET_COWS_LIVE")
        const q = query(collection(db, "EVENTS", event_id, "COWS"))
        
        const unsubscribe = onSnapshot(
            q,
            (querySnapshot) => {
                const modifiedList = [];
                const addedList = [];
                const removedList = [];
                
                querySnapshot.docChanges().forEach( (change)=>{
                    const cowData = {
                        ...(change.doc.data()),
                        id: change.doc.id
                    }

                    if (change.type === "added") {
                        addedList.push( cowData );
                    }
                    if (change.type === "modified") {
                        modifiedList.push( cowData );
                    }
                    if (change.type === "removed") {
                        removedList.push( cowData );
                    } 
                })

                cb_cows_live({modifiedList, addedList, removedList});
            }, (error) => {
                if (cb_error) {
                    cb_error(error)
                }else{
                    console.log(error)
                }
            })
        return (unsubscribe)

    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_cows_live:\n", error)
        }
        return (undefined)
    }
}




// ----------------------------------------------------------------------------


/**
 * importa, nell'evento indicato, la lista delle vacche (convertendo i parametri DATA)
 * 
 * @param {string} event_id - id evento
 * @param {list} cow_array - list dei dati delle vacche da importare
 * @param {list} date_key_list - lista dei nomi dei parametri che sono DATE e che quindi vanno convertiti in timestamp in firebase
 * @returns 
 */
export const import_cows = async (event_id, cow_array, date_key_list) => {
    console.log("import_cows:\n\t", event_id, "\n", cow_array, "\n", date_key_list)

    const res = await f_import_cow_array({ event_id, cow_array, date_key_list })
        .then((result) => {
            // Read result of the Cloud Function.
            /** @type {any} */
            const data = result.data;
            const retValue = data.retval;
            return retValue
        })
        .catch((error) => {
            // Getting the Error details.
            const code = error.code;
            const message = error.message;
            const details = error.details;
            console.error("Error in import_cows cloud function\nError [", code, "]: \n", message, "\n", details)
            return []
        });

    return res
}

/**
 * aggiorna il valore di un parametro su una lista di vacche (e una lista di valori)
 * 
 * @param {string} event_id - id dell'evento che contiene la lista delle "cows" su cui aggiornare il parametro
 * @param {string} param_name - nome del parametro da aggiornare
 * @param {Object} value_list - lista degli id dei documenti da modificare e dei valori per ogni document
 * @param {string} value_list.cow - id del doc 
 * @param {any} value_list.value - nuovo valore del parametro
 * @param {boolean} is_date - se è "true" i valori vengono convertiti in "timestap" prima di essere aggiornati nel doc
 * @returns 
 */
export const update_cows_param = async (event_id, param_name, value_list, is_date=false) => {
    console.log("update_cows_param ", event_id, " - ", param_name, " - ", value_list, " - ", is_date)
    
    const res = await f_update_cows_param({ event_id, param_name, value_list, is_date })
        .then((result) => {
            // Read result of the Cloud Function.
            /** @type {any} */
            const data = result.data;
            const retValue = data.retval;
            return retValue
        })
        .catch((error) => {
            // Getting the Error details.
            const code = error.code;
            const message = error.message;
            const details = error.details;
            console.error("Error in update_cows_param cloud function\nError [", code, "]: \n", message, "\n", details)
            return []
        });

    return res
}


/**
 *  Rimuove il parametro indicato dai document i cui id sono riportati nella lista 
 * 
 * @param {string} event_id - id dell'evento che contiene la lista delle "cows" su cui operare
 * @param {string} param_name - il nome del parametro da rimuovere
 * @param {list} cow_list - lista degli id dei document da cui rimuovere il parametro
 * @returns 
 */
export const delete_cows_param = async (event_id, param_name, cow_list) => {
    console.log("delete_cows_param ", event_id, " - ", param_name, " - ", cow_list)
    
    const res = await f_delete_cows_param({ event_id, param_name, cow_list})
        .then((result) => {
            // Read result of the Cloud Function.
            /** @type {any} */
            const data = result.data;
            const retValue = data.retval;
            return retValue
        })
        .catch((error) => {
            // Getting the Error details.
            const code = error.code;
            const message = error.message;
            const details = error.details;
            console.error("Error in delete_cows_param cloud function\nError [", code, "]: \n", message, "\n", details)
            return []
        });

    return res
}



// ----------------------------------------------------------------------------
/**
 * Cancella la collection COWS e tutti documenti cow al suo interno
 * 
 * @param {string} event_id - id dell'evento da cui cancellare la collection 
 * @returns 
 */
export const clear_all_cows = async (event_id) => {
    console.log("clear_all_cows ", event_id)
    
    const path = "EVENTS/" + event_id + "/COWS"
    const res = await f_recursive_delete({ path})
        .then((result) => {
            // Read result of the Cloud Function.
            /** @type {any} */
            const data = result.data;
            return data.path;
        })
        .catch((error) => {
            // Getting the Error details.
            const code = error.code;
            const message = error.message;
            const details = error.details;
            console.error("Error in clear_all_cows cloud function\nError [", code, "]: \n", message, "\n", details)
            return undefined
        });

    return res
}


// ------------------------------------------------------------------------
/**
 * 
 * @param {string} event_id
 * @param {string} cowman_id
 * @param {callback} cb_error 
 * @returns {count_total, count_present, count_not_present}
 */
export const get_cowman_stat = async (event_id, cowman_id, cb_error) => {
    try {
        const q_total = query(collection(db, "EVENTS", event_id, "COWS"), where("cowman.id", "==", cowman_id))
        const q_present = query(q_total, where("is_present", "==", true))
        const q_not_present = query(q_total, where("is_present", "==", false))


        let querySnapshot = await getCountFromServer(q_total);
        const count_total = querySnapshot.data().count;
        querySnapshot = await getCountFromServer(q_present);
        const count_present = querySnapshot.data().count;
        querySnapshot = await getCountFromServer(q_not_present);
        const count_not_present = querySnapshot.data().count;

       
        return ({cowman_id, count_total, count_present, count_not_present});
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_cowman_stat:\n", error)
        }
        return ({cowman_id})
    }
}


// ------------------------------------------------------------------------
/**
 * 
 * @param {string} event_id
 * @param {string} property_id
 * @param {callback} cb_error 
 * @returns {count_total, count_present, count_not_present}
 */
export const get_property_stat = async (event_id, property_id, cb_error) => {
    try {
        const q_total = query(collection(db, "EVENTS", event_id, "COWS"), where("property.id", "==", property_id))
        const q_present = query(q_total, where("is_present", "==", true))
        const q_not_present = query(q_total, where("is_present", "==", false))


        let querySnapshot = await getCountFromServer(q_total);
        const count_total = querySnapshot.data().count;
        querySnapshot = await getCountFromServer(q_present);
        const count_present = querySnapshot.data().count;
        querySnapshot = await getCountFromServer(q_not_present);
        const count_not_present = querySnapshot.data().count;

       
        return ({property_id, count_total, count_present, count_not_present});
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_property_stat:\n", error)
        }
        return ({property_id})
    }
}


// ------------------------------------------------------------------------
/**
 * 
 * @param {string} event_id

 * @param {callback} cb_error 
 * @returns {count_total, count_present, count_not_present}
 */
export const get_cows_stat = async (event_id, cowman_id, cb_error) => {
    try {
        const q_total = query(collection(db, "EVENTS", event_id, "COWS"))
        const q_present = query(q_total, where("is_present", "==", true))
        const q_not_present = query(q_total, where("is_present", "==", false))


        let querySnapshot = await getCountFromServer(q_total);
        const count_total = querySnapshot.data().count;
        querySnapshot = await getCountFromServer(q_present);
        const count_present = querySnapshot.data().count;
        querySnapshot = await getCountFromServer(q_not_present);
        const count_not_present = querySnapshot.data().count;

       
        return ({cowman_id, count_total, count_present, count_not_present});
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_cows_stat:\n", error)
        }
        return ({cowman_id})
    }
}